class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.content =
      this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.announcementBar = document.querySelector('.js-with-announcement-bar ');


    this.headerOverlay = document.querySelector('[data-js="header-overlay"]');
    this.dropdownMenuItems = Array.from(
      document.querySelectorAll('.js-header__menu-item')
    );
    this.dropdownMenuParents = Array.from(
      document.querySelectorAll('header-menu')
    );

    this.dropdownMenuParents.forEach((parent) => {
      parent.addEventListener('mouseenter', this.open.bind(this));
    });

    this.dropdownMenuParents.forEach((parent) => {
      parent.addEventListener('mouseleave', this.close.bind(this));
    });
  }

  open(event) {
    if (!this.header) return;

    const details = event.target.querySelector('.mega-menu__content');

    this.header.classList.add('header-menu-open');
    this.headerOverlay.classList.add('header-menu-open');

    if (this.announcementBar) {
      const announcementBarHeight = this.announcementBar
        ? this.announcementBar.offsetHeight
        : 54;
      this.headerOverlay.style.top = `${announcementBarHeight}px`;
    }

    details.classList.add('animation');
  }

  close(event) {
    if (event) {
      if (!this.header || (!event && !event.target)) return;

      this.header.classList.remove('header-menu-open');
      this.headerOverlay.classList.remove('header-menu-open');
    }

    if (event && event.target) {
      const details = event.target.querySelector('.mega-menu__content');
      details.classList.remove('animation');
    }
  }
}

customElements.define('header-menu', HeaderMenu);
